import React from 'react'
import {
  FormControl,
  OutlinedInput,
  Select,
  withStyles,
} from '@material-ui/core'

export default withStyles(theme => ({
  selectMenu: {
    minHeight: 0,
    height: 'auto',
    padding: '5px 14px',
  },
  select: {
    '&:focus': {
      borderRadius: 35,
    },
  },
  outlinedInputRoot: {
    '&$focused $notchedOutline': {
      borderColor: '#487648',
      borderWidth: 2,
    },
    '& $notchedOutline': {
      borderRadius: 28,
      paddingLeft: '40px !important',
    },
  },
  notchedOutline: {},
  focused: {},
}))(({ value, handleChange, items, classes }) => (
  <FormControl fullWidth variant="outlined">
    <Select
      classes={{ select: classes.select, selectMenu: classes.selectMenu }}
      value={value}
      onChange={e => handleChange(e.target.value)}
      input={
        <OutlinedInput
          labelWidth={0}
          classes={{
            root: classes.outlinedInputRoot,
            notchedOutline: classes.notchedOutline,
            focused: classes.focused,
          }}
        />
      }
    >
      {items}
    </Select>
  </FormControl>
))
